import {
    GetList,
    PostTeachingArea,
    DeleteTeachingArea,
    GetTeachingArea,
    PutTeachingArea,
} from '@src/services/teaching-area'
import { getSavedState } from '@src/utils/localStorage'

export const state = {
    listTeachingArea: [],
    teachingAreaFormState: {
        name: '',
        description: '',
        status: true,
        width: '',
        length: '',
        shallowDepth: '',
        bottomDepth: '',
        centerDepth: '',
        type: '',
        locationPublicId: '',
        publicId: '',
    },
    teachingAreaState: {
        locationId: '',
        qField: '',
        qStatus: true,
        qCurrentPage: 1,
        qPageSize: 20,
        Status: false,
    },
}

export const getters = {}

export const mutations = {
    FETCH_LOCALS(state, locals) {
        state.listTeachingArea = locals
    },
    SET_STATE(state, payload) {
        state.teachingAreaState = payload
    },
    SET_STATE_FORM(state, payload) {
        state.teachingAreaFormState = payload
    },
    UPDATE_PLAN(state, payload) {
        state.teachingAreaFormState = payload
    },
}

export const actions = {
    // retorna a lista de piscinas
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetList(locationPublicId, parameters)

        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
        }
    },
    async getPool({ commit }, parameters) {
        const resp = await GetTeachingArea(parameters)
        if (resp && resp.status === 200) {
            return resp.data.data
        }
    },
    async saveNewPool({ commit }, parameters) {
        const resp = await PostTeachingArea(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
            return true
        } else return false
    },
    async editPool({ commit }, parameters) {
        const resp = await PutTeachingArea(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
            return true
        } else return false
    },
    async delete({ commit, dispatch }, data) {
        const resp = await DeleteTeachingArea(data)
        if (resp.status === '200') {
            dispatch('fetchList')
        }
        return resp
    },
}
